import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import {
  IoMdLeaf,
  IoMdSunny,
  IoMdNutrition,
  IoMdFemale,
  IoMdPeople,
  IoMdGitNetwork,
  IoMdCheckmarkCircle
} from "react-icons/io";


import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';


import cln1 from '../assets/banner6.jpg';
import cln2 from '../assets/banner2.jpg';
import cln3 from '../assets/banner3.jpg';
import cln4 from '../assets/banner4.jpg';
import cln5 from '../assets/banner5.jpg';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
											}}
										>
											Good Governance
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">

								<HorizontalImageStrip
									images={[cln1, cln2, cln3, cln4]}
								/>

								<h6
									style={{
										fontSize: "18px",
										marginTop: "45px",
										marginBottom: "35px",
										textTransform: "uppercase",
										textAlign: "center"
									
									}}
								>
									good governance is a 
									&nbsp; 
									<span className="text-secondary"><b>critical component</b></span>
									&nbsp;
									of sustainable development
									<hr />
								</h6>

								<h5>
									We advocate for good governance practices and work with communities to promote transparency, accountability, and civic engagement. We engage with government agencies, civil society organizations, and other stakeholders to promote policies and practices that promote good governance. Through our programs, we aim to empower communities to be active participants in governance, creating a more just and equitable society.
									<br/><br/>
									At FPADI, we understand that good governance is essential for sustainable development. We advocate for good governance practices and work with communities to promote transparency, accountability, and civic engagement. Our good governance programs focus on empowering communities to be active participants in governance, promoting transparency and accountability, and advocating for policies and practices that promote good governance.
									<br/>
									We engage with government agencies, civil society organizations, and other stakeholders to promote policies and practices that promote good governance. We also work with communities to build their capacity to engage in governance processes, promoting civic engagement and participation. Through our programs, we aim to create a more just and equitable society, where all voices are heard, and all people have equal opportunities to participate in governance.
									<br/><br/>
									At FPADI, we understand that promoting good governance is a long-term process that requires sustained effort and collaboration. That’s why we work closely with communities, government agencies, and other stakeholders to implement our programs. We also advocate for policies and practices that promote good governance and transparency at all levels of society.
									<br/>
									Explore our case studies to see how our good governance programs have helped communities promote transparency, accountability, and civic engagement. At FPADI, we believe that good governance is essential for sustainable development, and we’re committed to making a difference.

								</h5>

								
							</div>

						</div>

					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}